import { render, staticRenderFns } from "./PopUpDetailFile.vue?vue&type=template&id=a250d19e&scoped=true&"
import script from "./PopUpDetailFile.vue?vue&type=script&lang=js&"
export * from "./PopUpDetailFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpDetailFile.vue?vue&type=style&index=0&id=a250d19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a250d19e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a250d19e')) {
      api.createRecord('a250d19e', component.options)
    } else {
      api.reload('a250d19e', component.options)
    }
    module.hot.accept("./PopUpDetailFile.vue?vue&type=template&id=a250d19e&scoped=true&", function () {
      api.rerender('a250d19e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpDetailFile.vue"
export default component.exports